module.exports = __webpack_public_path__ + "static/media/partner-icon-blockfrost-greyscale.26401832.svg";